// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"bc52fe31","134":"fbd4ad78","322":"e0603a50","325":"c5f04556","526":"8e5d57d2","552":"33b3564f","671":"45bb20dd","929":"02b5b105"}[chunkId] + ".chunk.js";
};